export const state = () => ({
    industries: [],
});
export const mutations = {
    setIndustries(state: any, payload: any) {
        state.industries = payload;
    },
};
export const getters = {
    getIndustries: (state: any) => state.industries,
};
export const actions = {
    async getIndustries(state: any, payload: any) {
        if (!(state.state.industries.length > 0)) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .get('/api/industries')
                    .then((res) => {
                        state.commit('setIndustries', res.data);
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        } else {
            return new Promise((resolve, reject) => {
                resolve(state.state.industries);
            });
        }
    },
    async fetchFieldsOfInterest(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .get('/api/industries/' + payload + '/fields-of-interest')
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};
